import { render } from "./RecaudoView.vue?vue&type=template&id=26f73464"
import script from "./RecaudoView.vue?vue&type=script&lang=js"
export * from "./RecaudoView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__